import { apiClient } from "lib/apiClient";

export interface IAssetDashboardCompetitiveSetItem {
  propertyId: string;
  propertyName: string;
  isSubject: boolean;
  distance: number | null;
  status: string | null;
  units: number | null;
  occupancyPercent: number | null;
  opened: number | null;
  marketArea: string | null;
  compDate: string | null;
  latitude: number | null;
  longitude: number | null;
}

export const getAssetDashboardCompetitiveSet = async (
  propertyId: string
): Promise<IAssetDashboardCompetitiveSetItem[]> => {
  const response = await apiClient.get(
    `/property/${propertyId}/asset-dashboard/competitive-set`
  );

  return response.data;
};
